import BaseModal from 'app/views/modals/base_modal';
import tmpl from 'templates/confirm_api_key_disable_modal';

export default BaseModal.extend({
  compiledTemplate: tmpl,

  initialize() {
    this.listenTo(this.model, 'change', this.render);
    this.$el.on('hidden.bs.modal', this.cancelDisable.bind(this));
  },

  events: {
    'click .cancel': 'cancelDisable',
    'click .disable-api-key': 'disableApiKey',
  },

  context() {
    return {
      active: this.model.get('active'),
      error: this.model.get('error'),
    };
  },
  disableApiKey() {
    this.model.disableApiKey({
      afterSave: () => {
        window.setTimeout(() => {
          this.close();
          this.model.unset('error');
        }, 4000);
      },
    });
  },
  cancelDisable() {
    // cancel the change and reset the view
    this.model.trigger('sync');
    this.close();
  },
});



// WEBPACK FOOTER //
// ./app/views/modals/confirm_api_key_disable_modal.js